/**
 * Balance Sheet (BE-17) — real API.
 *
 * Account-based: current and fixed assets, current liabilities and equity each list their accounts (`lines`) with a
 * total; contra accounts (accumulated depreciation, owner drawings) come negative. `asOfDate` defaults to today.
 */

import ApiService from '../api.service';
import { unwrapData } from '../../utils/apiConvert';

export const balanceSheetService = {
  // asOfDate as YYYY-MM-DD
  get: async ({ asOfDate } = {}) =>
    unwrapData(await ApiService.get('/api/reports/balance-sheet', { params: asOfDate ? { asOfDate } : {} })),
};

export default balanceSheetService;
